import { PageData } from "../../note";
import { isChartBlock } from "./block/chart";
import { isCodeBlockPageBlock } from "./block/codeBlock";
import { isComponentBlock } from "./block/component";
import { isCronBlock } from "./block/cron";
import { isPackageBlock } from "./block/package";
import { isSubscriptionBlock } from "./block/subscription";
import { isNoteBlock as isHtmlBlock } from "./block/html";
import { isimplementationBlock } from "./block/implementation";
import { isHttpHookBlock } from "./block/httpHook";
import { isLogStreamBlock } from "./block/logStream";
import { isNotePageBlock } from "./block/page";
import { isProtocolBlock } from "./block/protocol";
import { isPushConnectorBlock } from "./block/pushConnector";
import { isServiceAccountBlock } from "./block/serviceAccount";
import { isDevcontainerBlock } from "./block/devcontainer";
import { isVolumeBlock } from "./block/volume";
import { isWebSocketBlock } from "./block/webSocket";
import { isTableBlock } from "./block/table";

export interface NoteBlock {
  "block-index"?: number;
  type: string;
  "block-id": string;
  "page-id": string;
  "app-id": string;
}

export enum NoteBlockType {
  "HTML" = "html",
  "CHART" = "chart",
  "TABLE" = "table",
  "CODE" = "code",
  "PAGE" = "page",
  "COMPONENT" = "component",
  "PROTOCOL" = "protocol",
  "IMPLEMENTATION" = "implementation",
  "PUSH_CONNECTOR" = "push-connector",
  "LOG_STREAM" = "log-stream",
  "PACKAGE" = "package",
  "SUBSCRIPTION" = "subscription",
  "CRON" = "cron",
  "HTTP_HOOK" = "http-hook",
  "SERVICE_ACCOUNT" = "service-account",
  "DEVCONTAINER" = "devcontainer",
  "VOLUME" = "volume",
  "WEBSOCKET" = "websocket",
}

export interface NotePageData extends PageData {
  blocks: NoteBlock[];
}

export const getBlockType: (block: NoteBlock) => NoteBlockType = (block) => {
  if (isTableBlock(block)) {
    return NoteBlockType.TABLE;
  }
  if (isHtmlBlock(block)) {
    return NoteBlockType.HTML;
  }
  if (isChartBlock(block)) {
    return NoteBlockType.CHART;
  }
  if (isCodeBlockPageBlock(block)) {
    return NoteBlockType.CODE;
  }
  if (isNotePageBlock(block)) {
    return NoteBlockType.PAGE;
  }
  if (isComponentBlock(block)) {
    return NoteBlockType.COMPONENT;
  }
  if (isProtocolBlock(block)) {
    return NoteBlockType.PROTOCOL;
  }
  if (isimplementationBlock(block)) {
    return NoteBlockType.IMPLEMENTATION;
  }
  if (isPushConnectorBlock(block)) {
    return NoteBlockType.PUSH_CONNECTOR;
  }
  if (isPushConnectorBlock(block)) {
    return NoteBlockType.PUSH_CONNECTOR;
  }
  if (isLogStreamBlock(block)) {
    return NoteBlockType.LOG_STREAM;
  }
  if (isPackageBlock(block)) {
    return NoteBlockType.PACKAGE;
  }
  if (isCronBlock(block)) {
    return NoteBlockType.CRON;
  }
  if (isSubscriptionBlock(block)) {
    return NoteBlockType.SUBSCRIPTION;
  }
  if (isHttpHookBlock(block)) {
    return NoteBlockType.HTTP_HOOK;
  }
  if (isServiceAccountBlock(block)) {
    return NoteBlockType.SERVICE_ACCOUNT;
  }
  if (isDevcontainerBlock(block)) {
    return NoteBlockType.DEVCONTAINER;
  }
  if (isVolumeBlock(block)) {
    return NoteBlockType.VOLUME;
  }
  if (isWebSocketBlock(block)) {
    return NoteBlockType.WEBSOCKET;
  }
  throw new Error("Page block not recognized.");
};
